import { useEffect } from "react";
import { useLatestAlert } from "../../../hooks/useReduxSelectors";
import { useSnackbar } from "notistack";

const NotificationListener = ({ systemName }) => {
  const latestAlert = useLatestAlert();
  const { enqueueSnackbar } = useSnackbar();

  const determineMsgHeader = (systemName) => {
    if (systemName) {
      return systemName + ": " + latestAlert.Reason;
    } else {
      return latestAlert.Reason;
    }
  };

  useEffect(() => {
    if (latestAlert) {
      console.log("fire toast event", latestAlert);
      if (latestAlert.Reason) {
        enqueueSnackbar(determineMsgHeader(systemName), {
          variant: latestAlert.Category || "default",
        });
      }
    }
  }, [latestAlert, enqueueSnackbar]);

  return null;
};

export default NotificationListener;
